import { useTranslations } from '@vocab/react';
import { Alert, Text } from 'braid-design-system';

import translations from './.vocab';

export default function UnableToLoadUserError() {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="critical">
      <Text>{t('Sorry, we are unable to load user information...')}</Text>
    </Alert>
  );
}
